import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import {parsePlayerPointsValue} from 'helpers/number-helper';
import InputText from 'components/atoms/inputs/input-text';

class PlayerPoints extends Component {
    constructor(props) {
        super(props);
        this.isValueBeingChanged = false;
        this.state = {value: null};
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({value});
    }

    onBlur(value) {
        const player = this.getPlayer();

        if (!player) {
            return;
        }

        const {propName} = this.props;
        const mode = this.getMode();
        const correctValue = parsePlayerPointsValue(value.replace(',', '.'));

        this.onChange(correctValue);
        this.isValueBeingChanged = false;

        this.props.dispatch(
            Action.set(
                'UserPoints',
                [
                    {
                        playerId: player.getId(),
                        [propName]: correctValue,
                    },
                ],
                mode,
            ),
        );

        this.props.dispatch(
            Action.set('PlayersSympathy', {
                [mode]: {
                    [player.getId()]: null,
                },
            }),
        );
    }

    getPlayer() {
        const {players, playerId} = this.props;
        return players.getPlayer(playerId);
    }

    getValue(player) {
        const {propName} = this.props;
        const mode = this.getMode();
        return this.isValueBeingChanged ? this.state.value : player.getPropValueOfMode(propName, mode);
    }

    getMode() {
        const {mode = Const.FLEX_MODE, boundary} = this.props;

        return boundary.hasInnerMode(mode) ? mode : Const.FLEX_MODE;
    }

    getClassName(player, points) {
        const {className, userPointsType} = this.props;
        const classNames = [className];

        const params = {
            points,
            userPointsType: userPointsType.getUserPointsType(),
            mode: this.getMode(),
        };

        if (player.isUserPointsGreaterThan(params)) {
            classNames.push('points-down');
        } else if (player.isUserPointsLessThan(params)) {
            classNames.push('points-up');
        }

        return classNames.join(' ');
    }

    render() {
        const {tooltipSubject} = this.props;
        const player = this.getPlayer();

        if (!player) {
            return null;
        }

        const value = this.getValue(player);

        return (
            <InputText
                keyboard="number"
                value={value}
                className={this.getClassName(player, value)}
                onChange={::this.onChange}
                onBlur={::this.onBlur}
                testId="fpts-input"
                tooltipSubject={tooltipSubject}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {
        pointsBoundary,
        playersData: {players},
        userPointsType,
    } = state;

    return {
        boundary: pointsBoundary,
        players,
        userPointsType,
    };
}

export default connect(mapStatesToProps)(PlayerPoints);

export {PlayerPoints};
